import { useState } from 'react';
import { Link } from 'react-router-dom';
import { trendingSidebar } from '@/mocks/home';

export default function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [errorMsg, setErrorMsg] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;

    const honeypotEl = form.querySelector<HTMLInputElement>('input[name="website_alt"]');
    if (honeypotEl && honeypotEl.value.trim() !== '') {
      setStatus('success');
      setEmail('');
      return;
    }

    setStatus('loading');
    setErrorMsg('');

    try {
      const formData = new FormData(form);
      const response = await fetch('http://jsqcyl.cn/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });

      const responseText = await response.text();
      let parsed;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }

      if (response.ok && parsed?.code === 'OK') {
        setStatus('success');
        setEmail('');
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || responseText || '提交失败，请稍后再试';
        setStatus('error');
        setErrorMsg(serverMsg.includes('spam') ? '提交失败，请稍后再试' : serverMsg);
      }
    } catch {
      setStatus('error');
      setErrorMsg('网络错误，请检查网络后重试');
    }
  };

  return (
    <section className="py-14 md:py-20">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="bg-background-50 rounded-2xl border border-background-200/70 p-8 md:p-12 lg:p-16">
          <div className="flex flex-col lg:flex-row gap-8 lg:gap-12 items-start">
            <div className="w-full lg:w-7/12">
              <h2 className="text-3xl md:text-4xl font-heading text-foreground-900 mb-3">
                不错过任何瓜
              </h2>
              <p className="text-sm md:text-base text-foreground-600 mb-6 max-w-md">
                订阅吃瓜日报，每天第一时间收到最热的51个话题更新。一手八卦，绝不错过！
              </p>
              <form
                id="newsletter-main"
                onSubmit={handleSubmit}
                className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3"
               
              >
                <input
                  type="text"
                  name="website_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                  className="form-website-alt-field"
                />
                <input
                  type="email"
                  name="email"
                  required
                  placeholder="请输入您的邮箱地址"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="flex-1 h-12 px-5 text-sm bg-background-100 border border-background-200 rounded-full text-foreground-900 placeholder:text-foreground-400 outline-none focus:border-primary-400 transition-colors"
                />
                <button
                  type="submit"
                  disabled={status === 'loading'}
                  className="h-12 px-8 bg-primary-500 hover:bg-primary-600 disabled:bg-primary-300 text-background-50 rounded-full text-sm font-medium transition-colors cursor-pointer whitespace-nowrap flex items-center gap-2 justify-center"
                >
                  {status === 'loading' ? (
                    <>
                      <i className="ri-loader-4-line animate-spin"></i>
                      提交中...
                    </>
                  ) : (
                    <>
                      立即订阅
                      <i className="ri-arrow-right-line"></i>
                    </>
                  )}
                </button>
              </form>
              {status === 'success' && (
                <p className="mt-3 text-sm text-primary-600 font-medium">
                  订阅成功！感谢关注吃瓜51网，精彩内容即将送达。
                </p>
              )}
              {status === 'error' && (
                <p className="mt-3 text-sm text-red-600">
                  {errorMsg}
                </p>
              )}
            </div>

            <div className="w-full lg:w-5/12">
              <div className="bg-background-100 rounded-xl p-5 md:p-6">
                <h3 className="text-sm font-semibold text-foreground-900 mb-4 flex items-center gap-2 whitespace-nowrap">
                  <i className="ri-fire-line text-accent-500"></i>
                  实时热榜
                </h3>
                <div className="flex flex-col gap-1">
                  {trendingSidebar.map((item) => (
                    <Link
                      key={item.slug}
                      to="/"
                      className="flex items-center gap-3 px-3 py-2.5 rounded-lg hover:bg-background-200/50 transition-colors group cursor-pointer"
                    >
                      <span className={`w-6 h-6 flex items-center justify-center rounded-md text-xs font-bold flex-shrink-0 ${
                        item.rank <= 3
                          ? 'bg-primary-500 text-background-50'
                          : 'bg-background-200 text-foreground-600'
                      }`}>
                        {item.rank}
                      </span>
                      <span className="flex-1 text-sm text-foreground-700 group-hover:text-primary-600 transition-colors line-clamp-1">
                        {item.title}
                      </span>
                      <span className="text-xs text-foreground-500 flex-shrink-0 whitespace-nowrap">
                        {item.hotValue}
                      </span>
                    </Link>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}